import React from 'react';
import { GQLMoney } from '@jewelutions/core-crm-server-api-client-domain';

interface IProps {
  price: GQLMoney;
}

const PriceLabel: React.FC<IProps> = ({ price }: IProps) => {
  return (
    <React.Fragment>
      {price.amount} {price.currency}
    </React.Fragment>
  );
};

export default PriceLabel;
